import {
  CHART_COLORS,
  CHART_FONTS,
  CHART_STYLES,
  HighchartsOptions,
} from "../../../../../shared/component/pie-chart-simple/highcharts-common/highcharts-global-const";
import { KpiAnalysisChartDTO } from "../../../../dto/MetricPortfolioAnalysis";

export class KpiPortfolioAnalysisChartOptionsService {

  static getOptions(data: KpiAnalysisChartDTO, metricName: string, isTotalChart: boolean): HighchartsOptions {
    return {
      xAxis: {
        labels: {
          style: { fontSize: CHART_FONTS.font4, color: '#78909C' },
        },
        categories: data.xAxis,
        type: 'category',
        crosshair: true,
        scrollbar: CHART_STYLES.scrollbar,
      },
      yAxis: {
        title: {
          text: undefined,
        },
        labels: CHART_STYLES.yAxisLabelsStyle,
        stackLabels: CHART_STYLES.customKpiStackLabels,
      },
      legend: {
        enabled: false,
      },
      tooltip: CHART_STYLES.customTooltipKpiAnalysis,
      series: [{
        name: metricName,
        type: isTotalChart ? 'column' : 'line',
        marker: { enabled: isTotalChart },
        yAxis: 0,
        color: CHART_COLORS.main8,
        data: data.yAxis,
      }],
    };
  }
}
